import { Autocomplete } from 'devextreme-react/autocomplete';
import { Button } from 'devextreme-react/button';
import List from 'devextreme-react/list';
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import { AsyncRule, EmailRule, RequiredRule, Validator } from 'devextreme-react/validator';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import React, { useEffect, useRef, useState } from 'react';
import grantApi from '../../api/GrantApi.js';
import UserApi from '../../api/UserApi.js';
import '../css/GrantDetailsExternalUsers.css';
import { useAppContext } from '../shared/AppContext';
import { EXTERNALUSERROLE, ROLE, handleError } from '../shared/Utils';

const GrantDetailsExternalUsers = (props) => {

    const {
        canAssign,
        grantId,
        grantAor,
        grantAorEmail,
        popupLoaded,
        setSoSelectVisible
    } = props;

    const app = useAppContext();

    const [externalUsers, setExternalUsers] = useState([]);

    useEffect(() => {
        if (grantId !== undefined) {
            populateExternalUsers(grantId);
        }
    }, [grantId])

    const onError = async (error) => {
        console.log(error);

        const message = handleError(error);
    }

    const populateExternalUsers = async (grantId) => {
        const externalUsers = await grantApi.getGrantExternalUsers(grantId, onError);

        setExternalUsers(externalUsers);
    }

    const getExternalUsers = (role, key) => {
        var userList = externalUsers.filter(externalUser => externalUser.externalUserRole == role);

        return [{ key: key, items: userList }];
    }

    const onExternalUserAdded = async (emailAddress, firstName, lastName, role) => {
        const result = await grantApi.addGrantExternalUser(grantId, emailAddress, firstName, lastName, role, onError);

        if (result !== '') {
            notify(result, 'error', 2000);
        }

        await populateExternalUsers(grantId);
    };

    const onExternalUserUpdated = async () => {
        await populateExternalUsers(grantId);
    }

    const getValidExternalUserInfo = async (email) => {
        const result = await grantApi.getValidExternalUserInfo(email);
        return result;
    }

    const onExternalUserDeleted = async (data) => {
        await grantApi.deleteGrantExternalUser(data.grantId, data.externalUserId, data.externalUserRole, onError);
        await populateExternalUsers(data.grantId);
    };

    const getExternalUsersStore = (role) => {
        const externalUsersStore = new CustomStore({
            key: 'Value',
            useDefaultSearch: true,
            load: (loadOptions) => {
                if (loadOptions.filter !== undefined) {
                    const skip = loadOptions.skip;
                    const take = loadOptions.take;
                    const filter = (loadOptions.filter !== 'undefined') ? loadOptions.filter[0][2] : null;

                    return grantApi.getGrantExternalUsersFiltered(grantId, role, skip, take, filter, onError);
                } else {
                    return null;
                }
            },
        });

        return externalUsersStore;
    }

    let externalUserAccess = [];

    if (grantId !== undefined) {
        if (app.userRole !== ROLE.EXTERNAL_USER) {
            if (app.userPermissions.externalUserAccess != null) {
                externalUserAccess = app.userPermissions.externalUserAccess;
            }
        } else {
            // Gather all the permissions this user has for this grant
            for (let i = 0; i < app.externalUserRoles[grantId].length; i++) {
                const userPermissions = app.externalUserRoles[grantId][i];

                if (userPermissions.externalUserAccess !== null) {
                    externalUserAccess.push(...userPermissions.externalUserAccess);
                }
            }
        }
    }

    return (
        <div className="dx-scrollview-content">
            <div className="dx-list-group">
                <div className="dx-list-group-header dx-widget">Signing Official</div>
                <div className="dx-list-group-body">
                    <div className="dx-item dx-list-item dx-list-switchable-menu-item-shield-positioning dx-list-switchable-delete-ready" role="option">
                        <div className="dx-item-content dx-list-item-content dx-widget">{grantAor} ({grantAorEmail})</div>
                        <div className="dx-list-switchable-delete-button-container" style={{ transition: "none", right: "0px" }}>
                            <div className="dx-list-switchable-delete-button-wrapper">
                                <div className="dx-list-switchable-delete-button-inner-wrapper">
                                    <Button
                                        disabled={!canAssign}
                                        text="Assign SO"
                                        onClick={() => setSoSelectVisible(true)}
                                    ></Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {externalUserAccess.includes(EXTERNALUSERROLE.PROJECT_MANAGER) &&
                <ExternalUserList headingLabel="Project Manager" externalUserType={EXTERNALUSERROLE.PROJECT_MANAGER} singleUser={false} height={'auto'} grantId={grantId} getValidExternalUserInfo={getValidExternalUserInfo}
                    onExternalUserAdded={onExternalUserAdded} onExternalUserUpdated={onExternalUserUpdated} onExternalUserDeleted={onExternalUserDeleted} getExternalUsers={getExternalUsers} getExternalUsersStore={getExternalUsersStore} popupLoaded={popupLoaded} />
            }
            {externalUserAccess.includes(EXTERNALUSERROLE.AE_DESIGNER) &&
                <ExternalUserList headingLabel="AE Designers" externalUserType={EXTERNALUSERROLE.AE_DESIGNER} singleUser={false} height={'auto'} grantId={grantId} getValidExternalUserInfo={getValidExternalUserInfo}
                    onExternalUserAdded={onExternalUserAdded} onExternalUserUpdated={onExternalUserUpdated} onExternalUserDeleted={onExternalUserDeleted} getExternalUsers={getExternalUsers} getExternalUsersStore={getExternalUsersStore} popupLoaded={popupLoaded} />
            }
            {externalUserAccess.includes(EXTERNALUSERROLE.REVIEWER) &&
                <ExternalUserList headingLabel="Reviewers" externalUserType={EXTERNALUSERROLE.REVIEWER} singleUser={false} height={'auto'} grantId={grantId} getValidExternalUserInfo={getValidExternalUserInfo}
                    onExternalUserAdded={onExternalUserAdded} onExternalUserUpdated={onExternalUserUpdated} onExternalUserDeleted={onExternalUserDeleted} getExternalUsers={getExternalUsers} getExternalUsersStore={getExternalUsersStore} popupLoaded={popupLoaded} />
            }
        </div>
    );
}

export default GrantDetailsExternalUsers;

const ExternalUserList = ({ headingLabel, externalUserType, singleUser, height, grantId, getValidExternalUserInfo, onExternalUserAdded, onExternalUserUpdated, onExternalUserDeleted, getExternalUsers, getExternalUsersStore, popupLoaded }) => {
    const app = useAppContext();
    const userListRef = useRef(null);
    const addUserRowRef = useRef(null);

    const [editMode, setEditMode] = useState({});
    const editValidationGroups = useRef({});
    const editFirstNameTextBoxes = useRef({});
    const editLastNameTextBoxes = useRef({});

    const toggleEditMode = (id) => {
        setEditMode((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));

        if (editMode[id]) {
            // enable
            setTimeout(() => enableDeleteToggle(id), 250);
        }
        else if (!editMode[id]) {
            // disable
            setTimeout(() => disableDeleteToggle(id), 250);
        }
    };

    const enableDeleteToggle = (id) => {
        const button = document.getElementById(`AddButton${id}`);
        const listItemContent = button.closest(".dx-list-item-content"); // Move up to find the container
        if (listItemContent) {
            const toggleContainer = listItemContent.previousElementSibling; // The toggle container is right above
            if (toggleContainer && toggleContainer.classList.contains("dx-list-toggle-delete-switch-container")) {
                toggleContainer.classList.remove("external-delete-toggle");
            }
        }
    };

    const disableDeleteToggle = (id) => {
        const button = document.getElementById(`AddButton${id}`);
        const listItemContent = button.closest(".dx-list-item-content"); // Move up to find the container
        if (listItemContent) {
            const toggleContainer = listItemContent.previousElementSibling; // The toggle container is right above
            if (toggleContainer && toggleContainer.classList.contains("dx-list-toggle-delete-switch-container")) {
                toggleContainer.classList.add("external-delete-toggle");
            }
        }
    };

    const groupLoaded = useRef(popupLoaded);

    const externalUsersAddEmailAddress = useRef(null);
    const externalUsersAddFirstName = useRef(null);
    const externalUsersAddLastName = useRef(null);
    const externalUsersAddButton = useRef(null);

    const emailAddressValidation = useRef(null);
    const firstNameValidation = useRef(null);
    const lastNameValidation = useRef(null);

    const addIsSaving = useRef(false);

    useEffect(() => {
        if (externalUsersAddButton.current) {
            externalUsersAddButton.current.instance.option("disabled", true);
        }
    }, []);

    const handleAddButtonChanges = async () => {

        if (!addIsSaving.current) {

            var firstNameResult = firstNameValidation.current.instance.validate();
            var lastNameResult = lastNameValidation.current.instance.validate();

            if (firstNameResult.isValid && lastNameResult.isValid) {
                externalUsersAddButton.current.instance.option("disabled", false);
                return true;
            }
            else {
                externalUsersAddButton.current.instance.option("disabled", true);
                return false;
            }
        }
    }

    // Validate the email field, awaiting the async (already-registered) rule when pending
    const validateEmail = async () => {
        var result = emailAddressValidation.current.instance.validate();

        if (result.status === "pending") {
            var completed = await result.complete;
            return completed.isValid;
        }

        return result.isValid;
    }

    const onAddExternalUserClick = async (e) => {

        if (addIsSaving.current) {
            return;
        }

        var emailAddress = externalUsersAddEmailAddress.current.instance.option("value");
        var firstNameResult = firstNameValidation.current.instance.validate();
        var lastNameResult = lastNameValidation.current.instance.validate();

        // require a non-empty email (the email rules ignore empty values) before running format/async validation
        var emailIsValid = !!emailAddress?.trim() && await validateEmail();

        if (emailIsValid && firstNameResult.isValid && lastNameResult.isValid) {

            // handling save here
            // after save, reset add form

            addIsSaving.current = true;

            var firstName = externalUsersAddFirstName.current.instance.option("value");
            var lastName = externalUsersAddLastName.current.instance.option("value");

            await onExternalUserAdded(emailAddress, firstName, lastName, externalUserType);

            externalUsersAddEmailAddress.current.instance.option("value", null);
            externalUsersAddFirstName.current.instance.option("value", null);
            externalUsersAddLastName.current.instance.option("value", null);

            emailAddressValidation.current.instance.reset();
            firstNameValidation.current.instance.reset();
            lastNameValidation.current.instance.reset();

            addIsSaving.current = false;
        }
        else {
            externalUsersAddButton.current.instance.option("disabled", true);
        }
    };

    const addUserEnabled = () => {
        return !singleUser || getExternalUsers(externalUserType, headingLabel).length == 0;
    }

    const externalUserInfo = (data) => {

        var id = data.externalUserId;

        var email = data.emailAddress;

        if (data.firstName || data.lastName) {
            var name = `${data.firstName} ${data.lastName}`;
            email += ` (${name.trim()})`;
        }

        return (
            <div className={`externalUserEditing${editMode[id]}`}>
                <div className="row">
                    <div className="col-10" style={{ display: "flex", alignItems: "center" }}>
                        <span>{email}</span>
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                        <Button
                            className="externalUsersAddButton"
                            onClick={(e) => toggleEditMode(id)}
                            icon="edit"
                            id={`AddButton${id}`}
                            style={{ height: "30px" }}
                            visible={!editMode[id]}
                        >
                        </Button>
                    </div>
                </div>

                {
                    editMode[id] ? (
                        <div className="row">
                            <div className="col-10 d-flex">
                                <ValidationGroup ref={(el) => { if (el) editValidationGroups.current[id] = el.instance }}>
                                    <TextBox
                                        className="me-2"
                                        defaultValue={data.firstName}
                                        id={`firstNameTextBox${id}`}
                                        placeholder="First name"
                                        ref={(el) => { if (el) editFirstNameTextBoxes.current[id] = el.instance }}
                                        style={{ float: "left" }}
                                        validationGroup={id}
                                    >
                                        <Validator>
                                            <RequiredRule></RequiredRule>
                                        </Validator>
                                    </TextBox>
                                    <TextBox
                                        defaultValue={data.lastName}
                                        id={`lastNameTextBox${id}`}
                                        placeholder="Last name"
                                        ref={(el) => { if (el) editLastNameTextBoxes.current[id] = el.instance }}
                                        style={{ float: "right" }}
                                        validationGroup={id}
                                    >
                                        <Validator>
                                            <RequiredRule></RequiredRule>
                                        </Validator>
                                    </TextBox>
                                </ValidationGroup>
                            </div>
                            <div className="col-2 d-flex justify-content-end">
                                <Button
                                    id={`externalSaveButton${id}`}
                                    icon="save"
                                    onClick={(e) => updateExternalUser(data.externalUserId)}
                                >
                                </Button>
                                <Button
                                    id={`externalUndoButton${id}`}
                                    icon="undo"
                                    onClick={(e) => toggleEditMode(id)}
                                    style={{ marginLeft: "10px" }}
                                >
                                </Button>
                                <Button
                                    id={`externalDeleteButton${id}`}
                                    icon="trash"
                                    onClick={() => onItemDeleting(data)}
                                    style={{ marginLeft: "10px" }}
                                    visible={app.userId !== data.externalUserId}
                                >
                                </Button>
                            </div>
                        </div>
                    ) : <></>
                }

            </div>
        );
    }

    const updateExternalUser = async (id) => {
        const validationGroup = editValidationGroups.current[id];
        if (validationGroup) {
            const result = validationGroup.validate();
            if (result.isValid) {
                var firstName = editFirstNameTextBoxes.current[id].option("value");
                var lastName = editLastNameTextBoxes.current[id].option("value");
                await UserApi.updateUser(id, firstName, lastName);
                toggleEditMode(id);
                onExternalUserUpdated();
            }
        }
    }

    const onItemDeleting = (data) => {
        if (data.externalUserId === app.userId) {
            notify("You cannot delete yourself as a Project Manager", 'error', 2000);
        }

        if (editMode[data.externalUserId]) {
            onExternalUserDeleted(data);
        }
    };

    const collapseGroup = () => {
        if (externalUserType === EXTERNALUSERROLE.REVIEWER) {
            if (userListRef.current?.instance != null) {
                if (!groupLoaded.current) {
                    userListRef.current.instance.collapseGroup(0);
                    toggleAddUserRow(false);
                    groupLoaded.current = true;
                }
            }
        }
    }

    const toggleAddUserRow = (expanded) => {
        if (addUserRowRef.current != null) {
            addUserRowRef.current.style.display = (expanded) ? "" : "none";
        }
    }

    const groupRender = (data) => {
        return (
            <div
                className="externalUserListGroupHeader"
                onClick={groupClick}
            >{data.key}</div>
        )
    }

    const groupClick = () => {
        var listElement = userListRef.current.instance.element();
        var group = listElement.querySelector(".dx-list-group");
        // group will be collapsed when the group is clicked while it is expanded
        // the collapsed value will be true, so we are sending true to toggle expansion
        var groupIsCollapsed = group.classList.contains("dx-list-group-collapsed");
        console.log(groupIsCollapsed);
        toggleAddUserRow(groupIsCollapsed);
    }

    const emailExists = async (email) => {

        var firstName = null;
        var lastName = null;

        var emailAlreadyExists = false;

        if (userListRef.current) {

            // if here, we have list items to search

            var dataSource = userListRef.current.instance.option("dataSource");

            emailAlreadyExists = dataSource[0].items.some(item => item.emailAddress.toLowerCase() === email.toLowerCase());
        }

        if (!emailAlreadyExists) {

            var userInfo = await getValidExternalUserInfo(email);

            if (userInfo?.firstName || userInfo?.lastName) {
                firstName = userInfo.firstName;
                lastName = userInfo.lastName;

                externalUsersAddFirstName.current.instance.option("value", firstName);
                externalUsersAddLastName.current.instance.option("value", lastName);
            }
        }

        return !emailAlreadyExists;
    }

    const validationRequest = (email, grantId, externalUserRole) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(emailExists(email, grantId, externalUserRole));
            }, 250);
        });
    }

    return (<>
        {
            getExternalUsers(externalUserType, headingLabel)[0].items.length <= 0 ?
                (
                    <div className="dx-list-group">
                        <div style={{ borderTop: "0px" }} className="dx-list-group-header dx-widget">{headingLabel}</div>
                    </div>
                ) :
                (
                    <div className="externalUserList">
                        <List
                            allowItemDeleting={false}
                            collapsibleGroups={true}
                            dataSource={getExternalUsers(externalUserType, headingLabel)}
                            grouped={true}
                            groupRender={groupRender}
                            height={height}
                            itemDeleteMode={'none'}
                            itemRender={externalUserInfo}
                            keyExpr="id"
                            onContentReady={collapseGroup}
                            ref={userListRef}
                        />
                    </div>
                )}
        {
            addUserEnabled()
                ?
                <div ref={addUserRowRef} className="row externalUsersRow">
                    <div className="dx-field col-4">
                        <ValidationGroup ref={emailAddressValidation}>
                            <Autocomplete
                                dataSource={getExternalUsersStore(externalUserType, headingLabel)}
                                showClearButton={true}
                                onValueChanged={handleAddButtonChanges}
                                placeholder="Enter an email address..."
                                ref={externalUsersAddEmailAddress}
                                validationMessagePosition="right" >
                                <Validator>
                                    <EmailRule ignoreEmptyValue={true}
                                        message="Email is invalid" />
                                    <AsyncRule ignoreEmptyValue={true}
                                        message="Email is already registered"
                                        validationCallback={(params) => {
                                            return validationRequest(params.value, grantId, externalUserType);
                                        }}
                                    />
                                </Validator>
                            </Autocomplete>
                        </ValidationGroup>
                    </div>
                    <div className="dx-field col-3">
                        <ValidationGroup ref={firstNameValidation}>
                            <TextBox
                                className="externalUsersAddButton"
                                onValueChanged={handleAddButtonChanges}
                                placeholder="First name"
                                ref={externalUsersAddFirstName}
                            >
                                <Validator>
                                    <RequiredRule></RequiredRule>
                                </Validator>
                            </TextBox>
                        </ValidationGroup>
                    </div>
                    <div className="dx-field col-3">
                        <ValidationGroup ref={lastNameValidation}>
                            <TextBox
                                className="externalUsersAddButton"
                                onValueChanged={handleAddButtonChanges}
                                placeholder="Last name"
                                ref={externalUsersAddLastName}
                            >
                                <Validator>
                                    <RequiredRule></RequiredRule>
                                </Validator>
                            </TextBox>
                        </ValidationGroup>
                    </div>
                    <div className="dx-field col-2">
                        <Button
                            className="externalUsersAddButton"
                            onClick={onAddExternalUserClick}
                            ref={externalUsersAddButton}
                            text="Add"
                            width={100}
                        />
                    </div>
                </div> : null}
    </>);
}